import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    window.requestAnimationFrame(() => this.focusFirstInvalidField())
  }

  focusFirstInvalidField() {
    const field = this.element.querySelector("[aria-invalid='true']")
    if (!field) return

    field.scrollIntoView({ behavior: "smooth", block: "center" })
    field.focus({ preventScroll: true })
  }
}
